// frontend/src/config/contracts.js
// Fill in these addresses after running: cd contracts && npx hardhat run scripts/deploy.js --network flare

export const CONTRACT_ADDRESSES = {
  // Deployed to Flare mainnet - MODERATE preset deployment March 10, 2026
  EMBER_TOKEN:           "0x944b0f4016b6A12Fd7aCfdF0BDf5fce4C5B82Ed1",  // $EMBER ERC-20 token
  FACTORY:               "0xF11e9aE42Aa0FF1Dff1Bb5A621C49ae74DD81909",  // AMM factory (creates DEX trading pairs)
  ROUTER:                "0xE52Dc85842DD8d5d8a176D7cC50fD50b64Fbc7a6",  // Swap router
  MASTER_CHEF:           "0x8181C5f53FdEE1AEdEde1D6dE287109dCF0a7614",  // Yield farming rewards
  TREASURY:              "0xd6024731Ce7fA057e287ADEA7404aa6edBB3C458",  // Protocol fee collector / buyback-burn
  WRAPPED_TOKEN_FACTORY: "0xb115458C17536785772Ab93498D20cD776E0f2aB",  // Deploys wTOKEN contracts when tokens are approved

  // Already live on Flare mainnet
  WFLR: "0x1D80c49BbBCd1C0911346656B529DF9E5c2F783d",
  FTSO_REGISTRY: "0xaD67FE66660Fb8dFE9d6b1b4240d8650e30F6019", // Flare Time Series Oracle

  // EMBER/WFLR Trading Pair
  EMBER_WFLR_PAIR: "0x86b3A9331A3247380D6De1e292E69a9238bEdC0F",

  // LP Rewards - Deployed March 11, 2026
  LP_REWARDS: "0x4B97b031A2F05B8deFd06001D47AB5FdcE5cf7d4"
};

// ── ABIs (minimal – only the functions the frontend calls) ──────────────────

export const EMBER_TOKEN_ABI = [
  {
    type: 'function',
    name: 'name',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'string' }]
  },
  {
    type: 'function',
    name: 'symbol',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'string' }]
  },
  {
    type: 'function',
    name: 'decimals',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint8' }]
  },
  {
    type: 'function',
    name: 'totalSupply',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }]
  },
  {
    type: 'function',
    name: 'balanceOf',
    stateMutability: 'view',
    inputs: [{ type: 'address' }],
    outputs: [{ type: 'uint256' }]
  },
  {
    type: 'function',
    name: 'allowance',
    stateMutability: 'view',
    inputs: [
      { type: 'address', name: 'owner' },
      { type: 'address', name: 'spender' }
    ],
    outputs: [{ type: 'uint256' }]
  },
  {
    type: 'function',
    name: 'approve',
    stateMutability: 'nonpayable',
    inputs: [
      { type: 'address', name: 'spender' },
      { type: 'uint256', name: 'amount' }
    ],
    outputs: [{ type: 'bool' }]
  },
  {
    type: 'function',
    name: 'transfer',
    stateMutability: 'nonpayable',
    inputs: [
      { type: 'address', name: 'to' },
      { type: 'uint256', name: 'amount' }
    ],
    outputs: [{ type: 'bool' }]
  }
];

export const FACTORY_ABI = [
  {
    type: 'function',
    name: 'getPair',
    stateMutability: 'view',
    inputs: [
      { type: 'address', name: 'tokenA' },
      { type: 'address', name: 'tokenB' }
    ],
    outputs: [{ type: 'address' }]
  },
  {
    type: 'function',
    name: 'allPairs',
    stateMutability: 'view',
    inputs: [{ type: 'uint256' }],
    outputs: [{ type: 'address' }]
  },
  {
    type: 'function',
    name: 'allPairsLength',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }]
  },
  {
    type: 'function',
    name: 'createPair',
    stateMutability: 'nonpayable',
    inputs: [
      { type: 'address', name: 'tokenA' },
      { type: 'address', name: 'tokenB' }
    ],
    outputs: [{ type: 'address' }]
  }
];

export const PAIR_ABI = [
  {
    type: 'function',
    name: 'token0',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'address' }]
  },
  {
    type: 'function',
    name: 'token1',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'address' }]
  },
  {
    type: 'function',
    name: 'getReserves',
    stateMutability: 'view',
    inputs: [],
    outputs: [
      { type: 'uint112', name: 'reserve0' },
      { type: 'uint112', name: 'reserve1' },
      { type: 'uint32', name: 'blockTimestampLast' }
    ]
  },
  {
    type: 'function',
    name: 'totalSupply',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }]
  },
  {
    type: 'function',
    name: 'balanceOf',
    stateMutability: 'view',
    inputs: [{ type: 'address' }],
    outputs: [{ type: 'uint256' }]
  },
  {
    type: 'function',
    name: 'allowance',
    stateMutability: 'view',
    inputs: [
      { type: 'address', name: 'owner' },
      { type: 'address', name: 'spender' }
    ],
    outputs: [{ type: 'uint256' }]
  },
  {
    type: 'function',
    name: 'approve',
    stateMutability: 'nonpayable',
    inputs: [
      { type: 'address', name: 'spender' },
      { type: 'uint256', name: 'amount' }
    ],
    outputs: [{ type: 'bool' }]
  },
  {
    type: 'function',
    name: 'transfer',
    stateMutability: 'nonpayable',
    inputs: [
      { type: 'address', name: 'to' },
      { type: 'uint256', name: 'amount' }
    ],
    outputs: [{ type: 'bool' }]
  },
  {
    type: 'function',
    name: 'transferFrom',
    stateMutability: 'nonpayable',
    inputs: [
      { type: 'address', name: 'from' },
      { type: 'address', name: 'to' },
      { type: 'uint256', name: 'amount' }
    ],
    outputs: [{ type: 'bool' }]
  }
];

export const ROUTER_ABI = [
  {
    type: 'function',
    name: 'factory',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'address' }]
  },
  {
    type: 'function',
    name: 'WFLR',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'address' }]
  },
  {
    type: 'function',
    name: 'getAmountsOut',
    stateMutability: 'view',
    inputs: [
      { type: 'uint256' },
      { type: 'address[]' }
    ],
    outputs: [{ type: 'uint256[]' }]
  },
  {
    type: 'function',
    name: 'swapExactTokensForTokens',
    stateMutability: 'nonpayable',
    inputs: [
      { type: 'uint256' },
      { type: 'uint256' },
      { type: 'address[]' },
      { type: 'address' },
      { type: 'uint256' }
    ],
    outputs: [{ type: 'uint256[]' }]
  },
  {
    type: 'function',
    name: 'swapExactFLRForTokens',
    stateMutability: 'payable',
    inputs: [
      { type: 'uint256' },
      { type: 'address[]' },
      { type: 'address' },
      { type: 'uint256' }
    ],
    outputs: [{ type: 'uint256[]' }]
  },
  {
    type: 'function',
    name: 'swapExactTokensForFLR',
    stateMutability: 'nonpayable',
    inputs: [
      { type: 'uint256' },
      { type: 'uint256' },
      { type: 'address[]' },
      { type: 'address' },
      { type: 'uint256' }
    ],
    outputs: [{ type: 'uint256[]' }]
  },
  {
    type: 'function',
    name: 'addLiquidity',
    stateMutability: 'nonpayable',
    inputs: [
      { type: 'address' },
      { type: 'address' },
      { type: 'uint256' },
      { type: 'uint256' },
      { type: 'uint256' },
      { type: 'uint256' },
      { type: 'address' },
      { type: 'uint256' }
    ],
    outputs: [
      { type: 'uint256' },
      { type: 'uint256' },
      { type: 'uint256' }
    ]
  },
  {
    type: 'function',
    name: 'addLiquidityFLR',
    stateMutability: 'payable',
    inputs: [
      { type: 'address' },
      { type: 'uint256' },
      { type: 'uint256' },
      { type: 'uint256' },
      { type: 'address' },
      { type: 'uint256' }
    ],
    outputs: [
      { type: 'uint256' },
      { type: 'uint256' },
      { type: 'uint256' }
    ]
  },
  {
    type: 'function',
    name: 'removeLiquidity',
    stateMutability: 'nonpayable',
    inputs: [
      { type: 'address' },
      { type: 'address' },
      { type: 'uint256' },
      { type: 'uint256' },
      { type: 'uint256' },
      { type: 'address' },
      { type: 'uint256' }
    ],
    outputs: [
      { type: 'uint256' },
      { type: 'uint256' }
    ]
  },
  {
    type: 'function',
    name: 'removeLiquidityFLR',
    stateMutability: 'nonpayable',
    inputs: [
      { type: 'address' },
      { type: 'uint256' },
      { type: 'uint256' },
      { type: 'uint256' },
      { type: 'address' },
      { type: 'uint256' }
    ],
    outputs: [
      { type: 'uint256' },
      { type: 'uint256' }
    ]
  }
];

export const MASTER_CHEF_ABI = [
  {
    type: 'function',
    name: 'poolLength',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }]
  },
  {
    type: 'function',
    name: 'poolInfo',
    stateMutability: 'view',
    inputs: [{ type: 'uint256' }],
    outputs: [
      { type: 'address', name: 'lpToken' },
      { type: 'uint256', name: 'allocPoint' },
      { type: 'uint256', name: 'lastRewardBlock' },
      { type: 'uint256', name: 'accRewardPerShare' }
    ]
  },
  {
    type: 'function',
    name: 'userInfo',
    stateMutability: 'view',
    inputs: [
      { type: 'uint256', name: 'pid' },
      { type: 'address', name: 'user' }
    ],
    outputs: [
      { type: 'uint256', name: 'amount' },
      { type: 'uint256', name: 'rewardDebt' }
    ]
  },
  {
    type: 'function',
    name: 'pendingReward',
    stateMutability: 'view',
    inputs: [
      { type: 'uint256', name: 'pid' },
      { type: 'address', name: 'user' }
    ],
    outputs: [{ type: 'uint256' }]
  },
  {
    type: 'function',
    name: 'rewardPerBlock',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }]
  },
  {
    type: 'function',
    name: 'totalAllocPoint',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }]
  },
  {
    type: 'function',
    name: 'deposit',
    stateMutability: 'nonpayable',
    inputs: [
      { type: 'uint256', name: 'pid' },
      { type: 'uint256', name: 'amount' }
    ],
    outputs: []
  },
  {
    type: 'function',
    name: 'withdraw',
    stateMutability: 'nonpayable',
    inputs: [
      { type: 'uint256', name: 'pid' },
      { type: 'uint256', name: 'amount' }
    ],
    outputs: []
  },
  {
    type: 'function',
    name: 'emergencyWithdraw',
    stateMutability: 'nonpayable',
    inputs: [{ type: 'uint256', name: 'pid' }],
    outputs: []
  }
];

export const FTSO_REGISTRY_ABI = [
  {
    type: 'function',
    name: 'getCurrentPriceWithDecimals',
    stateMutability: 'view',
    inputs: [{ type: 'string', name: 'symbol' }],
    outputs: [
      { type: 'uint256', name: 'price' },
      { type: 'uint256', name: 'timestamp' },
      { type: 'uint256', name: 'decimals' }
    ]
  }
];

export const WFLR_ABI = [
  {
    type: 'function',
    name: 'deposit',
    stateMutability: 'payable',
    inputs: [],
    outputs: []
  },
  {
    type: 'function',
    name: 'withdraw',
    stateMutability: 'nonpayable',
    inputs: [{ type: 'uint256', name: 'amount' }],
    outputs: []
  },
  {
    type: 'function',
    name: 'balanceOf',
    stateMutability: 'view',
    inputs: [{ type: 'address' }],
    outputs: [{ type: 'uint256' }]
  }
];

export const LP_REWARDS_ABI = [
  {
    type: 'function',
    name: 'getPendingRewards',
    stateMutability: 'view',
    inputs: [
      { type: 'address', name: 'pair' },
      { type: 'address', name: 'user' }
    ],
    outputs: [
      { type: 'uint256', name: 'token0Pending' },
      { type: 'uint256', name: 'token1Pending' }
    ]
  },
  {
    type: 'function',
    name: 'getPoolFees',
    stateMutability: 'view',
    inputs: [{ type: 'address', name: 'pair' }],
    outputs: [
      { type: 'uint256', name: 'token0Fees' },
      { type: 'uint256', name: 'token1Fees' }
    ]
  },
  {
    type: 'function',
    name: 'getUserRewards',
    stateMutability: 'view',
    inputs: [
      { type: 'address', name: 'pair' },
      { type: 'address', name: 'user' }
    ],
    outputs: [
      { type: 'uint256', name: 'token0Earned' },
      { type: 'uint256', name: 'token1Earned' },
      { type: 'uint256', name: 'lastClaim' }
    ]
  },
  {
    type: 'function',
    name: 'claimRewards',
    stateMutability: 'nonpayable',
    inputs: [{ type: 'address', name: 'pair' }],
    outputs: []
  },
  {
    type: 'function',
    name: 'initializePool',
    stateMutability: 'nonpayable',
    inputs: [{ type: 'address', name: 'pair' }],
    outputs: []
  },
  {
    type: 'function',
    name: 'isAutoCompoundEnabled',
    stateMutability: 'view',
    inputs: [
      { type: 'address', name: 'pair' },
      { type: 'address', name: 'user' }
    ],
    outputs: [{ type: 'bool' }]
  },
  {
    type: 'function',
    name: 'setAutoCompound',
    stateMutability: 'nonpayable',
    inputs: [
      { type: 'address', name: 'pair' },
      { type: 'bool', name: 'enabled' }
    ],
    outputs: []
  },
  {
    type: 'function',
    name: 'autoCompound',
    stateMutability: 'nonpayable',
    inputs: [
      { type: 'address', name: 'pair' },
      { type: 'uint256', name: 'amountAMin' },
      { type: 'uint256', name: 'amountBMin' },
      { type: 'uint256', name: 'deadline' }
    ],
    outputs: [{ type: 'uint256', name: 'liquidity' }]
  },
  {
    type: 'event',
    name: 'RewardsClaimed',
    inputs: [
      { type: 'address', indexed: true, name: 'user' },
      { type: 'address', indexed: true, name: 'pair' },
      { type: 'uint256', name: 'token0Amount' },
      { type: 'uint256', name: 'token1Amount' }
    ]
  },
  {
    type: 'event',
    name: 'RewardsCompounded',
    inputs: [
      { type: 'address', indexed: true, name: 'user' },
      { type: 'address', indexed: true, name: 'pair' },
      { type: 'uint256', name: 'token0Amount' },
      { type: 'uint256', name: 'token1Amount' },
      { type: 'uint256', name: 'liquidityMinted' }
    ]
  },
  {
    type: 'event',
    name: 'AutoCompoundEnabled',
    inputs: [
      { type: 'address', indexed: true, name: 'user' },
      { type: 'address', indexed: true, name: 'pair' },
      { type: 'bool', name: 'enabled' }
    ]
  }
];
